import { Outlet } from "react-router-dom";
import { vendorsRoutes } from "./Vendors/vendors-routes";
import { productsCategoriesRoutes } from "./Categories/categories-routes";
import SuperAdminProductList from "./Products/SuperAdminProducts";
import { returnsRoutes } from "./Returns/return-routes";

export const marketplaceRoutes = [
    {
        path: "marketplace",
        element: Outlet,
        children: [
            {
                path: "",
                redirect: "products",
            },
            {
                path: "products",
                element: SuperAdminProductList,
            },
            ...vendorsRoutes,
            ...productsCategoriesRoutes,
            ...returnsRoutes,
        ]
    }
]